import type { Stripe } from "@stripe/stripe-js";

type StripeEnv = "sandbox" | "live";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

function paymentsEnvironment(): StripeEnv {
  if (clientToken?.startsWith("pk_test_")) return "sandbox";
  if (clientToken?.startsWith("pk_live_")) return "live";
  throw new Error(
    "Payments are not configured for this build. Complete payment go-live to enable checkout.",
  );
}

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * stripe-js is imported dynamically so the SDK never lands in the shared
 * vendor bundle: pages without a checkout must not pay for it.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    paymentsEnvironment();
    stripePromise = import("@stripe/stripe-js").then((m) => m.loadStripe(clientToken as string));
  }
  return stripePromise;
}

export function getStripeEnvironment(): StripeEnv {
  return paymentsEnvironment();
}

export const MEMBERSHIP_PRICE_ID = "retail_leaders_circle_annual";
